module.exports = __webpack_public_path__ + "icon_money.d50dbc.png";


//////////////////
// WEBPACK FOOTER
// ./app/modules/images/icon_money.png
// module id = 550
// module chunks = 0